/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RewardConfigResponse } from './RewardConfigResponse';
import {
    RewardConfigResponseFromJSON,
    RewardConfigResponseFromJSONTyped,
    RewardConfigResponseToJSON,
    RewardConfigResponseToJSONTyped,
} from './RewardConfigResponse';
import type { RewardGrantResponse } from './RewardGrantResponse';
import {
    RewardGrantResponseFromJSON,
    RewardGrantResponseFromJSONTyped,
    RewardGrantResponseToJSON,
    RewardGrantResponseToJSONTyped,
} from './RewardGrantResponse';

/**
 * Collection contains prize pools that can be won by users in a challenge
 * @export
 * @interface PrizePool
 */
export interface PrizePool {
    /**
     * 
     * @type {string}
     * @memberof PrizePool
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof PrizePool
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof PrizePool
     */
    updatedAt: number;
    /**
     * 
     * @type {number}
     * @memberof PrizePool
     */
    quantity: number;
    /**
     * Number of prizes that have been rewarded
     * @type {number}
     * @memberof PrizePool
     */
    quantityRewarded?: number;
    /**
     * 
     * @type {number}
     * @memberof PrizePool
     */
    priority: number;
    /**
     * 
     * @type {boolean}
     * @memberof PrizePool
     */
    notifiedWinner?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PrizePool
     */
    winnerMessage?: string;
    /**
     * 
     * @type {RewardConfigResponse}
     * @memberof PrizePool
     */
    rewardConfig?: RewardConfigResponse;
    /**
     * 
     * @type {RewardGrantResponse}
     * @memberof PrizePool
     */
    rewardGrant?: RewardGrantResponse;
    /**
     * Multiple images for prize bundle carousel
     * @type {Array<string>}
     * @memberof PrizePool
     */
    imageIds?: Array<string>;
    /**
     * CDN URLs for prize bundle images
     * @type {Array<string>}
     * @memberof PrizePool
     */
    imageUrls?: Array<string>;
}

/**
 * Check if a given object implements the PrizePool interface.
 */
export function instanceOfPrizePool(value: object): value is PrizePool {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('quantity' in value) || value['quantity'] === undefined) return false;
    if (!('priority' in value) || value['priority'] === undefined) return false;
    return true;
}

export function PrizePoolFromJSON(json: any): PrizePool {
    return PrizePoolFromJSONTyped(json, false);
}

export function PrizePoolFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrizePool {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'quantity': json['quantity'],
        'quantityRewarded': json['quantityRewarded'] == null ? undefined : json['quantityRewarded'],
        'priority': json['priority'],
        'notifiedWinner': json['notifiedWinner'] == null ? undefined : json['notifiedWinner'],
        'winnerMessage': json['winnerMessage'] == null ? undefined : json['winnerMessage'],
        'rewardConfig': json['rewardConfig'] == null ? undefined : RewardConfigResponseFromJSON(json['rewardConfig']),
        'rewardGrant': json['rewardGrant'] == null ? undefined : RewardGrantResponseFromJSON(json['rewardGrant']),
        'imageIds': json['imageIds'] == null ? undefined : json['imageIds'],
        'imageUrls': json['imageUrls'] == null ? undefined : json['imageUrls'],
    };
}

export function PrizePoolToJSON(json: any): PrizePool {
    return PrizePoolToJSONTyped(json, false);
}

export function PrizePoolToJSONTyped(value?: PrizePool | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'quantity': value['quantity'],
        'quantityRewarded': value['quantityRewarded'],
        'priority': value['priority'],
        'notifiedWinner': value['notifiedWinner'],
        'winnerMessage': value['winnerMessage'],
        'rewardConfig': RewardConfigResponseToJSON(value['rewardConfig']),
        'rewardGrant': RewardGrantResponseToJSON(value['rewardGrant']),
        'imageIds': value['imageIds'],
        'imageUrls': value['imageUrls'],
    };
}

